import React, { useState, useEffect } from 'react';
import GetMonths from '../../Dropdowns/getMonths';
import GetYears from '../../Dropdowns/getYears';
import CBReport_Dist from './CBReport_Dist';
import CBReport_Fps from './CBReport_Fps';

const Unconsolidate_Consolidated_Cb = ({ heading }) => {
    const [renderContent, setRenderContent] = useState(null);
    const [loadingMonths, setLoadingMonths] = useState(true);
    const [loadingYears, setLoadingYears] = useState(true);
    const [currentMonth, setCurrentMonth] = useState('');
    const [currentYear, setCurrentYear] = useState('');
    const [error, setError] = useState(null);

    const [districtDrop, setDistrictDrop] = useState([]);
    const [mandalDrop, setMandalDrop] = useState([]);

    const [district, setDistrict] = useState({ id: "0", name: "" })
    const [mandal, setMandal] = useState({ id: "all", name: "ALL" })


    useEffect(() => {
        if (!loadingMonths && !loadingYears && currentMonth && currentYear) {
            const timer = setTimeout(() => {
                handleSubmit();
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [loadingMonths, loadingYears, currentMonth, currentYear]);


    useEffect(() => {

        setDistrictDrop([])
        setMandalDrop([])

        const fecthData = async () => {

            const response = await fetch(`${process.env.REACT_APP_URL_SALE}/reports/get-all-district`)
            const data = await response.json()
            setDistrictDrop(data)

        }

        fecthData()



    }, [])


    useEffect(() => {

        setMandalDrop([])
        setMandal({ id: "all", name: "ALL" })

        if (district.id != '0') {

            const fecthData = async () => {
                const response = await fetch(`${process.env.REACT_APP_URL_SALE}/reports/get-dist-mandal/${district.id}`)
                const data = await response.json()
                setMandalDrop(data)
            }
            fecthData()
        }



    }, [district.id])

    const handleMonthsLoadingChange = (isLoading) => {
        setLoadingMonths(isLoading);
    };

    const handleYearsLoadingChange = (isLoading) => {
        setLoadingYears(isLoading);
    };

    const handleSubmit = () => {
        const monthSelect = document.getElementById('month');
        const yearSelect = document.getElementById('year');

        const month = monthSelect ? monthSelect.value : currentMonth;
        const year = yearSelect ? yearSelect.value : currentYear;

        if (!month || month === '0' || month === '') {
            alert('Please select Month');
            return;
        }
        if (!year || year === '0' || year === '') {
            alert('Please select Year');
            return;
        }


        if (district.id == '0') {
            alert('please select the district');
            return;
        }

        setError(null);
        setRenderContent(null);
        setTimeout(() => {
            // setRenderContent(
            //     <CBReport_Dist
            //         month={month}
            //         year={year}
            //         heading={heading}
            //     />
            // );



            setRenderContent(<CBReport_Fps
                month={month}
                year={year}
                dist_code={district.id}
                dist_name={district.name}
                afso_code={mandal.id}
                afso_name={mandal.name}
            />)
        }, 0);
    };

    const handleBack = () => {
        setRenderContent(null);
        setError(null);
    };

    return (
        <>
            <table width="30%" align='center' style={{ marginTop: '20px', borderCollapse: 'collapse' }}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan="8">
                            Concealed and Reconciled Stock for Allotment
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Month:</td>
                        <td>
                            <GetMonths
                                selectedMonth={currentMonth}
                                onLoadingChange={handleMonthsLoadingChange}
                            />
                        </td>
                        <td>Year:</td>
                        <td>
                            <GetYears
                                selectedYear={currentYear}
                                onLoadingChange={handleYearsLoadingChange}
                            />
                        </td>

                        <td>
                            District</td>                        <td>
                            <select value={district.id}
                                onChange={e =>
                                    setDistrict({
                                        id: e.target.value,
                                        name: e.target.options[e.target.selectedIndex].text
                                    })
                                }>
                                <option value="0">Select District</option>
                                {districtDrop.map(d => (
                                    <option key={d.id} value={d.id}>{d.name}</option>
                                ))}
                            </select>
                        </td>

                        <td>
                            Mandal/Block                            </td>
                        <td>
                            <select value={mandal.id}
                                onChange={(e) => setMandal({ id: e.target.value, name: e.target.options[e.target.selectedIndex].text })}
                            >
                                <option value="all">ALL Mandal/Block</option>
                                {
                                    mandalDrop.map((item, index) => (
                                        <option value={item.id}>{item.name}</option>
                                    ))
                                }
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="8" align="center" style={{ padding: '10px' }}>
                            <button
                                onClick={handleSubmit}
                                className="button button2"
                                disabled={loadingMonths || loadingYears}
                            >
                                Submit
                            </button>
                            <button
                                onClick={handleBack}
                                className="button button2"
                                style={{ marginLeft: '10px' }}
                            >
                                Back
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            {error && (
                <div
                    align="center"
                    style={{
                        margin: '20px',
                        fontWeight: 'bold',
                        color: 'brown',
                        textDecoration: 'underline',
                        fontSize: '18px'
                    }}
                >
                    {error}
                </div>
            )}
            <br />
            <div id="details1">{renderContent}</div>
        </>
    );
};

export default Unconsolidate_Consolidated_Cb;

